/**
 * cookie操作
 * 注意：1.存入cookie的敏感信息必须加密
 *      2.cookie设置有效时间
 * 更高级的cookie安全问题请自行百度
 */
export default {
 
  /**
   * 设置cookie
   * @param tel 登陆者账号
   * @param name 登陆者昵称
   * @param day cookie过期时间（单位：天）
   */
  setCookie(name, value, seconds) {
    seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
    var expires = "";
    if(seconds != 0) { //设置cookie生存时间
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
  },
 
  /**
   * 获取cookie
   * @param key 需要对应值的key
   * @returns value key所对应的值
   * document.cookie直接获取的cookie原格式：userTel=***********; userName=***
   * 注意：获取原cookie格式的";"后含有一个空格
   */
  getCookie(name) {
    if(document.cookie.length > 0) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';'); //把cookie分割成组
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i]; //取得字符串
          while(c.charAt(0) == ' ') { //判断一下字符串有没有前导空格
              c = c.substring(1, c.length); //有的话，从第二位开始取
          }
          if(c.indexOf(nameEQ) == 0) { //如果含有我们要的name
              return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值
          }
      }
      return false;
    }
    return null
  },
  /**
   * 清除cookie
   * 将cookie的数据设空，时间设0
   */
  clearCookie: function() {
    this.setCookie("", "", 0);
  },
  SetlocalStorage:function(value,keyStr) {
    var encryptedData = this.Encrypt(value);
    localStorage.setItem(keyStr, encryptedData);
    this.setCookie(keyStr,encryptedData,86400);
  },
  GetlocalStorage:function(keyStr) {
    var userData = localStorage.getItem(keyStr);

    if (!userData) {
        userData= this.getCookie(keyStr);
    }
    
    if (userData) {
        var decryptedStr = this.Decrypt(userData);
        if (decryptedStr) {
          var curdate = new Date();
          var startTime=new Date(JSON.parse(decryptedStr).startTime);
          var oldDate=new Date(startTime.setDate(startTime.getDate() + 1));
          //如果登录时的时间加上1天小于当前时间
          if(oldDate<curdate){
                //缓存过期，清除缓存
                this.ClearlocalStorage(keyStr);
                return "";
          }else{
                //缓存未过期，返回值
                return decryptedStr;
          }
        }else{
          return "";
        }
    }else {
        return "";
    }
  },
  ClearlocalStorage:function(keyStr) {
    localStorage.clear();
    this.setCookie(keyStr, null, -1);
  }
  ,
  Encrypt: function (str) {
    var key = CryptoJS.enc.Utf8.parse("9c7b9399680658d308691f2acad58c0a"); 
    var iv = CryptoJS.enc.Utf8.parse("8NONwyJtHesysWpM");
    var encrypted = '';
    var srcs = CryptoJS.enc.Utf8.parse(str);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.ciphertext.toString();
  },
  Decrypt: function (str) {
    var key = CryptoJS.enc.Utf8.parse("9c7b9399680658d308691f2acad58c0a");
    var iv = CryptoJS.enc.Utf8.parse("8NONwyJtHesysWpM");
    var encryptedHexStr = CryptoJS.enc.Hex.parse(str);
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    var decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
   },
   isMobile:function(){
        if(navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
      ){
        return true;
      }else{
        return false;
      }
    },
    GetQueryString:function(variable){
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
      }
      return(false);
    } 
}


// WEBPACK FOOTER //
// ./src/action/cookie.js